var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAwesomeTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 36,
    viewBox: "0 0 45 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-truck",
    "data-name": "Icon awesome-truck",
    d: "M43.875,24.75H42.75v-7.6a3.375,3.375,0,0,0-.991-2.384L34.734,7.741a3.375,3.375,0,0,0-2.384-.991h-3.1V3.375A3.376,3.376,0,0,0,25.875,0H3.375A3.376,3.376,0,0,0,0,3.375v22.5A3.376,3.376,0,0,0,3.375,29.25H4.5a6.75,6.75,0,0,0,13.5,0h9a6.75,6.75,0,0,0,13.5,0h3.375A1.128,1.128,0,0,0,45,28.125v-2.25A1.128,1.128,0,0,0,43.875,24.75ZM11.25,32.625a3.375,3.375,0,1,1,3.375-3.375A3.376,3.376,0,0,1,11.25,32.625Zm22.5,0a3.375,3.375,0,1,1,3.375-3.375A3.376,3.376,0,0,1,33.75,32.625ZM39.375,18H29.25V10.125h3.1l7.024,7.024Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeTruck);
export default __webpack_public_path__ + "static/media/Icon-awesome-truck.ba033596eb7e5ef4bd2ad79e0fe0fccc.svg";
export { ForwardRef as ReactComponent };